import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";

import { Loading, SelectableCard } from "@/ds";

import {
  BUSCAR_LOCAL_PLACEHOLDER,
  CONFLITO_DESCRICAO_CURTA,
  DISPONIVEL_LABEL,
  INDISPONIVEL_LABEL,
  LOCAIS_EMPTY_MESSAGE,
  LOCAIS_LOAD_ERROR_MESSAGE,
  LOCAL_SECTION_LABEL,
  OBRA_SECTION_LABEL,
  PERIODO_ALOCADO_LABEL,
  PERIODO_OBRA_LABEL,
} from "../../resolver-conflito-local.constants";
import styles from "./selecionar-local-step.module.scss";
import type { SelecionarLocalStepViewModel } from "./types-selecionar-local-step";

export function SelecionarLocalStepView({
  localNome,
  localCidadeUf,
  obras,
  errors,
  search,
  locais,
  escolherObra,
  escolherSubstituto,
  buscar,
}: SelecionarLocalStepViewModel) {
  return (
    <>
      <div className={styles.resumo} data-testid="resolver-conflito-resumo-curto">
        <span>
          <strong>{localNome}</strong> • Local
        </span>
        <span>{localCidadeUf}</span>
        <span className={styles.resumoInfo}>
          <i className="pi pi-info-circle" aria-hidden />
          {CONFLITO_DESCRICAO_CURTA}
        </span>
      </div>

      <fieldset className={styles.secao} aria-describedby="resolver-conflito-obra-error">
        <legend className={styles.secaoTitulo}>{OBRA_SECTION_LABEL}</legend>
        <div className={styles.opcoes}>
          {obras.map((obra) => (
            <SelectableCard
              key={obra.id}
              value={obra.id}
              selected={obra.marcada}
              name="resolver-conflito-obra"
              onSelect={escolherObra}
              className={errors.obra ? styles.invalida : undefined}
              data-testid="resolver-conflito-obra-option"
            >
              <span className={styles.opcaoCorpo}>
                <span className={styles.opcaoTitulo}>{obra.titulo}</span>
                <span className={styles.opcaoMeta}>
                  <i className="pi pi-briefcase" aria-hidden />
                  {PERIODO_OBRA_LABEL}: {obra.periodoObra}
                </span>
                <span className={styles.opcaoMeta}>
                  <i className="pi pi-user" aria-hidden />
                  {PERIODO_ALOCADO_LABEL}: {obra.periodoAlocado}
                </span>
              </span>
            </SelectableCard>
          ))}
        </div>
        {errors.obra ? (
          <span
            id="resolver-conflito-obra-error"
            className={styles.erro}
            role="alert"
            data-testid="resolver-conflito-obra-error"
          >
            {errors.obra}
          </span>
        ) : null}
      </fieldset>

      <fieldset className={styles.secao} aria-describedby="resolver-conflito-local-error">
        <legend className={styles.secaoTitulo}>{LOCAL_SECTION_LABEL}</legend>
        <IconField iconPosition="left" className={styles.busca}>
          <InputIcon className="pi pi-search" />
          <InputText
            className={styles.buscaCampo}
            value={search}
            placeholder={BUSCAR_LOCAL_PLACEHOLDER}
            aria-label={BUSCAR_LOCAL_PLACEHOLDER}
            maxLength={100}
            onChange={(event) => buscar(event.target.value)}
            data-testid="resolver-conflito-busca"
          />
        </IconField>

        {locais.tipo === "carregando" ? (
          <div className={styles.estado} data-testid="resolver-conflito-locais-loading">
            <span>
              <Loading size="sm" aria-hidden /> Carregando locais...
            </span>
          </div>
        ) : null}

        {locais.tipo === "erro" ? (
          <div className={styles.estado} role="alert" data-testid="resolver-conflito-locais-error">
            {LOCAIS_LOAD_ERROR_MESSAGE}
          </div>
        ) : null}

        {locais.tipo === "vazio" ? (
          <div className={styles.estado} data-testid="resolver-conflito-locais-empty">
            {LOCAIS_EMPTY_MESSAGE}
          </div>
        ) : null}

        {locais.tipo === "lista" ? (
          <ul
            className={`${styles.lista} ${errors.local ? styles.invalida : ""}`}
            data-testid="resolver-conflito-locais"
          >
            {locais.opcoes.map((item) => (
              <li key={item.id}>
                <SelectableCard
                  value={item.id}
                  selected={item.marcado}
                  disabled={item.indisponivel}
                  name="resolver-conflito-local"
                  onSelect={escolherSubstituto}
                  className={styles.item}
                  data-testid="resolver-conflito-local-option"
                >
                  <span className={styles.itemMeta}>
                    <span className={styles.itemNome}>{item.nome}</span>
                    <span className={styles.itemPapel}>{item.cidadeUf}</span>
                  </span>
                  <Tag
                    className="p-tag-xs"
                    severity={item.indisponivel ? "warning" : "success"}
                    value={item.indisponivel ? INDISPONIVEL_LABEL : DISPONIVEL_LABEL}
                  />
                </SelectableCard>
              </li>
            ))}
          </ul>
        ) : null}

        {errors.local ? (
          <span
            id="resolver-conflito-local-error"
            className={styles.erro}
            role="alert"
            data-testid="resolver-conflito-local-error"
          >
            {errors.local}
          </span>
        ) : null}
      </fieldset>
    </>
  );
}
